import axios from 'axios';

import { Dispatch, SetStateAction, useContext } from 'react';
import { AnyIfEmpty } from 'react-redux';
import { NavigateFunction } from 'react-router-dom';
import { AvailabilityRedirectionContext } from '../../../components/context/availabilityRedirection';
import {
    ADD_AVAILABILITY_FAILURE,
    ADD_AVAILABILITY_REQUEST,
    ADD_AVAILABILITY_SUCCESS,
    GET_AVAILABILITIES_FAILURE,
    GET_AVAILABILITIES_LOGS_FAILURE,
    GET_AVAILABILITIES_LOGS_REQUEST,
    GET_AVAILABILITIES_LOGS_RESET,
    GET_AVAILABILITIES_LOGS_SUCCESS,
    GET_AVAILABILITIES_REQUEST,
    GET_AVAILABILITIES_SUCCESS,
    GET_CONFLICTED_AVAILABILITY_FAILURE,
    GET_CONFLICTED_AVAILABILITY_REQUEST,
    GET_CONFLICTED_AVAILABILITY_SUCCESS,
    REMOVE_CONFLICTED_AVAILABILITY_FAILURE,
    REMOVE_CONFLICTED_AVAILABILITY_REQUEST,
    REMOVE_CONFLICTED_AVAILABILITY_SUCCESS,
    REMOVE_EXISTING_AVAILABILITY_REQUEST,
} from '../constants/availability.constant';
import { HistoryParamsProps } from '../../../components/visits/AppointmentAvailabilityLogs/AppointmentLogs/AppointmentLogs.interface';

// Add availability
const addAvailabilityRequest = () => {
    return {
        type: ADD_AVAILABILITY_REQUEST,
    };
};

const addAvailabilitySuccess = (addAvailabilityData: AnyIfEmpty<object>) => {
    return {
        type: ADD_AVAILABILITY_SUCCESS,
        payload: addAvailabilityData,
    };
};

const addAvailabilityFailure = (addAvailabilityError: string) => {
    return {
        type: ADD_AVAILABILITY_FAILURE,
        payload: addAvailabilityError,
    };
};

// Get conflicted availability

const getConflictedAvailabilityRequest = () => {
    return {
        type: GET_CONFLICTED_AVAILABILITY_REQUEST,
    };
};

const getConflictedAvailabilitySuccess = (conflictedAvailabilityData: AnyIfEmpty<object>) => {
    return {
        type: GET_CONFLICTED_AVAILABILITY_SUCCESS,
        payload: conflictedAvailabilityData,
    };
};

const getConflictedAvailabilityFailure = (conflictedAvailabilityError: string) => {
    return {
        type: GET_CONFLICTED_AVAILABILITY_FAILURE,
        payload: conflictedAvailabilityError,
    };
};

// Get conflicted availability
const getAvailabilitiesRequest = () => {
    return {
        type: GET_AVAILABILITIES_REQUEST,
    };
};

const getAvailabilitiesSuccess = (availabilitiesData: AnyIfEmpty<object>) => {
    return {
        type: GET_AVAILABILITIES_SUCCESS,
        payload: availabilitiesData,
    };
};

const getAvailabilitiesFailure = (availabilitiesError: string) => {
    return {
        type: GET_AVAILABILITIES_FAILURE,
        payload: availabilitiesError,
    };
};

// Remove confilicated availabilites
const removeConflictedAvailabilityRequest = () => {
    return {
        type: REMOVE_CONFLICTED_AVAILABILITY_REQUEST,
    };
};

const removeConflictedAvailabilitySuccess = (removeConflictData: AnyIfEmpty<object>) => {
    return {
        type: REMOVE_CONFLICTED_AVAILABILITY_SUCCESS,
        payload: removeConflictData,
    };
};

const removeConflictedAvailabilityFailure = (removeConflictError: string) => {
    return {
        type: REMOVE_CONFLICTED_AVAILABILITY_FAILURE,
        payload: removeConflictError,
    };
};

const removeExistingAvailabilityRequest = () => {
    return {
        type: REMOVE_EXISTING_AVAILABILITY_REQUEST,
    };
};

// Get Availabilities Logs

const getAvailabilitiesLogsRequest = () => {
    return {
        type: GET_AVAILABILITIES_LOGS_REQUEST,
    }
}

const getAvailabilitiesLogsSuccess = (availabilitiesLogsData: AnyIfEmpty<object>) => {
    return {
        type: GET_AVAILABILITIES_LOGS_SUCCESS,
        payload: availabilitiesLogsData,
    }
}

const getAvailabilitiesLogsFailure = (availabilitiesLogsError: string) => {
    return {
        type: GET_AVAILABILITIES_LOGS_FAILURE,
        payload: availabilitiesLogsError
    }
}

// const removeExistingAvailabilitySuccess = (removedData: AnyIfEmpty<object>) => {
//     return {
//         type: REMOVE_EXISTING_AVAILABILITY_SUCCESS,
//         payload: removedData,
//     };
// };

// const removeExistingAvailabilityFailure = (removeAvailabilityError: string) => {
//     return {
//         type: REMOVE_EXISTING_AVAILABILITY_FAILURE,
//         payload: removeAvailabilityError,
//     };
// };

// Add availability

export const addAvailability = (
    addAvailabilityObj: AnyIfEmpty<object>,
    location?: string,
    navigate?: NavigateFunction,
    setStep?: Dispatch<SetStateAction<number>>,
    setConfirmLoading?: Dispatch<SetStateAction<boolean>>,
    isRedirectToVisitor?: boolean,
) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(addAvailabilityRequest());
        return await axios
            .post('/admin/availabilities', addAvailabilityObj)
            .then((response) => {
                dispatch(addAvailabilitySuccess(response.data));
                dispatch(getAvailabilities(location));
                setConfirmLoading?.(false);
                isRedirectToVisitor ? navigate?.('/create-appointment') : navigate?.('/visits');
                setStep?.(4);
            })
            .catch((err) => dispatch(addAvailabilityFailure(err.message)));
    };
};

// Get conflicted availability

export const getConflictedAvailability = (conflictedAvailability: AnyIfEmpty<object>) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getConflictedAvailabilityRequest());
        return await axios
            .post('admin/availabilities/confilicated-availabilites', conflictedAvailability)
            .then((response) => dispatch(getConflictedAvailabilitySuccess(response.data.result)))
            .catch((error) => getConflictedAvailabilityFailure(error.message));
    };
};

// remove conflicted availabilites

export const removeConflictedAvailability = (id: string, conflictedAvailabilityObj: AnyIfEmpty<object>) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(removeConflictedAvailabilityRequest());
        return await axios
            .delete(`/admin/availabilities/delete-exisiting-availabilites/${id}`)
            .then((response) => {
                dispatch(removeConflictedAvailabilitySuccess(response.data));
                dispatch(getConflictedAvailability(conflictedAvailabilityObj));
            })
            .catch((error) => dispatch(removeConflictedAvailabilityFailure(error.message)));
    };
};

export const getAvailabilities = (location?: string) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getAvailabilitiesRequest());
        return await axios
            .get(`/admin/availabilities/unit-availabilities`, {
                params: {
                    location,
                },
            })
            .then((response) => {
                dispatch(getAvailabilitiesSuccess(response.data.data));
            })
            .catch((error) => dispatch(getAvailabilitiesFailure(error.message)));
    };
};

export const removeExistingAvailability = (availabilityId: string | undefined, location: string, reason: string) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(removeExistingAvailabilityRequest());
        return await axios
            .delete(`/admin/availabilities/delete-exisiting-availabilites/${availabilityId}`, {
                data: {
                    reason: reason,
                },
            })
            .then(() => {
                dispatch(getAvailabilities(location));
            })
            .catch((error) => dispatch(removeConflictedAvailabilityFailure(error.message)));
    };
};

export const getAvailabilityAppointmentLogs = (
    locationId: string,
    historyParams: HistoryParamsProps,
) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getAvailabilitiesLogsRequest());
        return await axios
            .get(`/admin/availabilities/get-availability-logs/${locationId}`, {
                params: {
                    startDate: historyParams.startDate,
                    endDate: historyParams.endDate,
                    page: historyParams.page,
                    limit: historyParams.limit,
                },
            })
            .then((response) => {
                dispatch(getAvailabilitiesLogsSuccess(response?.data))
            })
            .catch((error) => {
                dispatch(getAvailabilitiesLogsFailure(error?.message))
            })
    };
};

export const resetAvailabilityLogs = () => {
    return {
        type: GET_AVAILABILITIES_LOGS_RESET
    }
}
